/* tslint:disable */
/* eslint-disable */
export enum JofiUploadCategoryEnum {
  Generic = 'GENERIC',
  Profilbild = 'PROFILBILD',
  Schulzeugnis = 'SCHULZEUGNIS',
  SchnupperPraktika = 'SCHNUPPER_PRAKTIKA',
  Lebenslauf = 'LEBENSLAUF'
}
